var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

(function() {
  const translations = window.theme && window.theme.strings ? window.theme.strings : {};

  function validateMinOrder(cartContainer) {
    const cartItems = cartContainer.querySelectorAll('[data-min-order]');
    const errors = [];
    
    cartItems.forEach(function(item) {
      const minOrder = Number(item.getAttribute('data-min-order') || 1);
      if (minOrder <= 1) return;
      
      const qtyInput = item.querySelector('.qty');
      
      if (!qtyInput) return;
      
      const quantity = Number(qtyInput.value || 0);
      
      if (quantity < minOrder) {
        errors.push({
          item: item,
          minOrder: minOrder,
          quantity: quantity,
          needed: minOrder - quantity
        });
      }
    });
    
    return errors;
  }

  function showErrorMessages(errors, cartContainer) {
    errors.forEach(function(error) {
      const item = error.item;
      const existingError = item.querySelector('.cart-item__min-order-error');
      
      if (existingError) {
        existingError.remove();
      }
      
      const errorMessage = document.createElement('div');
      errorMessage.className = 'cart-item__min-order-error';
      errorMessage.textContent = (translations.minOrderError || 'Add {{ count }} more item(s) to meet minimum order requirement').replace('{{ count }}', error.needed);
      
      const itemName = item.querySelector('.item__name');
      const itemContentName = item.querySelector('.item__content-name');
      const targetContainer = itemName || itemContentName || item.querySelector('.item__content');
      
      if (targetContainer) {
        targetContainer.appendChild(errorMessage);
      }
      
      item.classList.add('cart-item__error');
    });
  }

  function clearErrorMessages(cartContainer) {
    const errorMessages = cartContainer.querySelectorAll('.cart-item__min-order-error');
    errorMessages.forEach(function(msg) {
      msg.remove();
    });
    
    const errorItems = cartContainer.querySelectorAll('.cart-item__error');
    errorItems.forEach(function(item) {
      item.classList.remove('cart-item__error');
    });
  }

  function handleCheckoutClick(evt) {
    const target = evt.target;
    const isCheckoutButton = target.classList.contains('btn-checkout') || 
                             (target.tagName === 'BUTTON' && target.name === 'checkout') ||
                             (target.tagName === 'A' && target.href && target.href.includes('/checkout'));
    
    if (!isCheckoutButton) return;
    
    const minCart = document.querySelector('.minicart');
    const cartPage = document.querySelector('.page-cart');
    const cartContainer = minCart || cartPage;
    
    if (!cartContainer) return;
    
    clearErrorMessages(cartContainer);
    const errors = validateMinOrder(cartContainer);
    
    if (errors.length > 0) {
      evt.preventDefault();
      evt.stopPropagation();
      
      showErrorMessages(errors, cartContainer);
      
      const firstError = errors[0].item;
      if (firstError) {
        setTimeout(function() {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
      
      return false;
    }
  }

  function initCartValidation() {
    document.addEventListener('click', handleCheckoutClick, true);
    
    const cartForm = document.querySelector('.page-cart form[action="/cart"]');
    if (cartForm) {
      cartForm.addEventListener('submit', function(evt) {
        const submitButton = document.activeElement;
        if (submitButton && submitButton.name === 'checkout') {
          const cartPage = document.querySelector('.page-cart');
          if (cartPage) {
            clearErrorMessages(cartPage);
            const errors = validateMinOrder(cartPage);
            
            if (errors.length > 0) {
              evt.preventDefault();
              evt.stopPropagation();
              
              showErrorMessages(errors, cartPage);
              
              const firstError = errors[0].item;
              if (firstError) {
                firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
              
              return false;
            }
          }
        }
      });
    }

    document.addEventListener('input', function(evt) {
      if (evt.target.classList.contains('qty')) {
        const item = evt.target.closest('[data-min-order]');
        if (item) {
          const cartContainer = item.closest('.minicart') || item.closest('.page-cart');
          if (cartContainer) {
            clearErrorMessages(cartContainer);
          }
        }
      }
    });

    document.addEventListener('change', function(evt) {
      if (evt.target.classList.contains('qty')) {
        const item = evt.target.closest('[data-min-order]');
        if (item) {
          const cartContainer = item.closest('.minicart') || item.closest('.page-cart');
          if (cartContainer) {
            clearErrorMessages(cartContainer);
          }
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartValidation);
  } else {
    initCartValidation();
  }
})();